import React, { ReactNode } from 'react'
import styled from 'styled-components'

import {
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

const Paper = styled(MuiPaper)(spacing)

const DetailTableHead = () => (
  <TableHead>
    <TableRow>
      <TableCell colSpan={2} />
    </TableRow>
  </TableHead>
)

interface EditableValueProps {
  children: ReactNode
}

export const EditableValue = (props: EditableValueProps) => {
  const { children } = props
  return (
    <TableCell component="th" scope="row" align="right">
      {children}
    </TableCell>
  )
}

interface EditableTitleProps {
  children: ReactNode
}

export const EditableTitle = (props: EditableTitleProps) => {
  const { children } = props
  return (
    <TableCell component="th" scope="row">
      {children}
    </TableCell>
  )
}

interface EditableRowProps {
  children: ReactNode
}

export const EditableRow = (props: EditableRowProps) => {
  const { children } = props
  return <TableRow hover>{children}</TableRow>
}

interface EditableFieldProps {
  children: ReactNode
  label: string
}

export const EditableField = (props: EditableFieldProps) => {
  const { children, label } = props
  return (
    <EditableRow>
      <EditableTitle>{label}</EditableTitle>
      <EditableValue>{children}</EditableValue>
    </EditableRow>
  )
}

interface EditableTableProps {
  children: ReactNode
}

export const EditableTable = (props: EditableTableProps) => {
  const { children } = props
  return (
    <Paper>
      <TableContainer>
        <Table aria-labelledby="tableTitle" size={'small'} aria-label="enhanced table">
          <DetailTableHead />
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
